import React from 'react';
import { Button, Container, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PageNotFound() {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        <ErrorOutlineIcon sx={{ fontSize: 100, color: 'error.main' }} />
        <Typography variant="h3" gutterBottom>
          404 - Page non trouvée
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          La page que vous cherchez n'existe pas ou a été déplacée.
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          component={Link} 
          to="/dashboard"
          sx={{ 
            backgroundColor: '#7C3AED',
            '&:hover': { backgroundColor: '#6D28D9' }
          }}
        >
          Retour au tableau de bord
        </Button>
      </Box>
    </Container>
  );
}

export default PageNotFound;